var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 32,
    viewBox: "0 0 51 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7619 0.166504C4.23375 0.166504 2.76819 0.773104 1.68762 1.85286C0.607056 2.93261 0 4.39708 0 5.92408V23.1968C0 24.7238 0.607056 26.1883 1.68762 27.268C2.76819 28.3478 4.23375 28.9544 5.7619 28.9544H14.4048V23.1968H5.7619V5.92408H14.4048V0.166504H5.7619ZM23.0476 0.166504C21.5195 0.166504 20.0539 0.773104 18.9733 1.85286C17.8928 2.93261 17.2857 4.39708 17.2857 5.92408V23.1968C17.2857 24.7238 17.8928 26.1883 18.9733 27.268C20.0539 28.3478 21.5195 28.9544 23.0476 28.9544H28.8095C30.3377 28.9544 31.8032 28.3478 32.8838 27.268C33.9644 26.1883 34.5714 24.7238 34.5714 23.1968V5.92408C34.5714 4.39708 33.9644 2.93261 32.8838 1.85286C31.8032 0.773104 30.3377 0.166504 28.8095 0.166504H23.0476ZM23.0476 5.92408H28.8095V23.1968H23.0476V5.92408ZM37.4524 10.2423V14.5604H46.0952V18.8786H41.7738C40.6277 18.8786 39.5285 19.3336 38.7181 20.1434C37.9077 20.9532 37.4524 22.0516 37.4524 23.1968V31.8332H50.4167V27.515H41.7738V23.1968H46.0952C47.2414 23.1968 48.3405 22.7419 49.1509 21.932C49.9614 21.1222 50.4167 20.0239 50.4167 18.8786V14.5604C50.4167 13.4152 49.9614 12.3168 49.1509 11.507C48.3405 10.6972 47.2414 10.2423 46.0952 10.2423H37.4524Z",
    fill: "#12491D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCo2);
export default __webpack_public_path__ + "static/media/co2.984e322507bc32dc57941ab6cc4dbe8c.svg";
export { ForwardRef as ReactComponent };